import { __assign } from "tslib";
import { createHttpTestKit } from '../../../http/test-kit';
import { createTextsApi, textsApiRelativePath, textDefaultsApiRelativePath, hcTextsApiRelativePath } from './index';
import { createFakePostResponder } from '../../../test-utils';
import { createFakeGetResponder } from './../../../test-utils';
export var createTextsApiTestKit = function () {
    var fakeHttp = createHttpTestKit();
    var api = createTextsApi('', fakeHttp);
    // @ts-ignore - Ignore the error here, or handle wildcard ('*') param
    var testKit = {
        whenGetTextOverrides: function (dto) {
            return createFakeGetResponder(fakeHttp, textsApiRelativePath + "/" + dto.locale + (dto.brandId ? "?brandId=" + dto.brandId : ''));
        },
        whenUpdateTextOverrides: function (dto) {
            return createFakePostResponder(fakeHttp, textsApiRelativePath + "/" + dto.locale)(dto.brandId ? __assign(__assign({}, dto.data), { brandId: dto.brandId }) : dto.data);
        },
        whenGetCustomTexts: function (dto) {
            return createFakeGetResponder(fakeHttp, hcTextsApiRelativePath + "/" + dto.locale + "/contentAndStructure/customKeys" + (dto.brandId ? "?brandId=" + dto.brandId : ''));
        },
        whenUpdateCustomTexts: function (dto) {
            return createFakePostResponder(fakeHttp, hcTextsApiRelativePath + "/" + dto.locale + "/contentAndStructure/customKeys")(dto.brandId ? __assign(__assign({}, dto.data), { brandId: dto.brandId }) : dto.data);
        },
        whenGetHCTextDefaults: function (dto) {
            return createFakeGetResponder(fakeHttp, "" + dto.tenantDefaultHost + textDefaultsApiRelativePath + "/" + dto.locale + (dto.brandId ? "?brandId=" + dto.brandId : ''));
        }
    };
    return __assign(__assign({}, api), testKit);
};
//# sourceMappingURL=testkit.js.map